import React from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUIDataTable from "mui-datatables";
import Chip from "@mui/material/Chip";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import NewCustomer from "./Components/NewCustomer";
import Customer from "./Components/Customer";
import useSave from "../../Hooks/useSave";
import { useEffect } from "react";
import { useState } from "react";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import IconMenu from "../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import CustomerGroups from "./CustomerGroups";
import Order from "./Components/components/Order";

function Customers() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchGraphql, DialogSave } = useSave();
  const [customers, setCustomers] = useState([]);

  const menuHeader = {
    icon: "",
    name: "Customers",
  };

  const menu = [
    { link: "/customers/customer-groups", name: "Customer Groups" },
    { link: "/customers", name: "Customers" },
  ];

  const addonOptions = {
    open: (tableMeta) => {
      navigate(`/customers/customer/${tableMeta.rowData[0]}/company-info`);
    },
    delete: (tableMeta) => {
      fetchGraphql({
        query: `mutation DeleteCustomer($customerId: ID) {
          deleteCustomer(customerId: $customerId)
        }`,
        variables: { customerId: tableMeta.rowData[0] },
      });
    },
    edit: false,
  };

  const [textField, selectField, newRecord, actions, options] =
    useDatatableAddon(customers, setCustomers, "customerId", addonOptions);

  useEffect(() => {
    fetchGraphql({
      query: `query Customers {
        customers {
          customerId
          customerName
          customerPhoneNumber
          customerBillingEmails
          customerGroupCode
          customerType
          customerPricelist
        }
      }`,
    }).then((result) => {
      try {
        const customers1 = result.data.customers.map((item) => {
          const billingEmail = item.customerBillingEmails?.split(",")[0];

          return {
            ...item,
            customerBillingEmails: billingEmail,
          };
        });
        setCustomers(customers1);
      } catch (error) {
        console.log(error);
      }
    });
  }, [location.pathname === "/customers"]);

  const columns = [
    {
      name: "customerId",
      options: {
        display: false,
      },
    },
    {
      name: "customerName",
      label: "Customer Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            firstRow: true,
            width: "200px",
          };

          return textField(tableMeta, value, options);
        },
      },
    },
    {
      name: "customerPhoneNumber",
      label: "Customer Phone",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "200px",
          };
          return textField(tableMeta, value, options);
        },
      },
    },
    {
      name: "customerBillingEmails",
      label: "Customer Emails",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "200px",
          };
          return textField(tableMeta, value, options);
        },
      },
    },
    {
      name: "customerType",
      label: "Customer Type",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "200px",
          };
          return textField(tableMeta, value, options);
        },
      },
    },
    {
      name: "customerGroupCode",
      label: "Customer Group",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            tabNext: true,
            width: "200px",
            values: [],
          };

          return selectField(tableMeta, value, options);
        },
      },
    },
    {
      name: "customerPricelist",
      label: "Customer Pricelist",
    },
    { ...actions },
  ];

  return (
    <MiniDrawer key="1">
      {() => (
        <>
          <DialogSave />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              // overflow: "hi",
              height: "100%",
              // flexGrow: "50"
            }}
          >
            <Routes>
              <Route
                path="/"
                element={
                  <Box
                    sx={{
                      display: "flex",
                      flexDireection: "row",
                      width: "100%",
                    }}
                  >
                    <IconMenu menuHeader={menuHeader} menu={menu} />

                    <Paper
                      sx={{
                        width: "100%",
                        height: "auto",
                        marginLeft: "20px",
                        padding: "20px",
                        overflow: "auto",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{ margin: "0px 0px 20px 0px", marginLeft: "auto" }}
                        onClick={() => navigate("new-customer")}
                      >
                        <AddIcon />
                        New Customer
                      </Button>

                      <MUIDataTable
                        title={"Customers"}
                        data={customers}
                        columns={columns}
                        options={options}
                      />
                    </Paper>
                  </Box>
                }
              />
              <Route path="/customer-groups" element={<CustomerGroups />} />
              <Route path="/new-customer" element={<NewCustomer />} />
              <Route
                path="/customer/:customerId/orders/order/:id/order"
                element={<Order />}
              />
              <Route path="/customer/:customerId/*" element={<Customer />} />
            </Routes>
          </Box>
        </>
      )}
    </MiniDrawer>
  );
}

export default Customers;
